import React from "react";
import { UsersRound, Layers, BadgeCheck, Handshake, Clock } from "lucide-react";

function WhyUs() {
  const items = [
    {
      icon: UsersRound,
      title: "Industry Exposure",
      desc: "Work on real-time projects with industry experts.",
    },
    {
      icon: Layers,
      title: "Skill Development",
      desc: "Enhance technical & soft skills for your career.",
    },
    {
      icon: BadgeCheck,
      title: "Internship Certificate",
      desc: "Get recognized internship completion certificate.",
    },
    {
      icon: Handshake,
      title: "Placement Support",
      desc: "Top performers get PPO & placement support.",
    },
    {
      icon: Clock,
      title: "Flexible Duration",
      desc: "Choose from short-term or long-term internships.",
    },
  ];

  return (
    <section className="bg-white dark:bg-[#050505] px-6 lg:px-16 py-10">
      <div className="max-w-7xl mx-auto rounded-xl bg-[#070b0d] border border-white/10 shadow-[0_0_35px_rgba(0,0,0,0.18)] px-6 py-8">
        <h2 className="text-center text-white text-3xl md:text-4xl font-bold  mb-8">
          Why Intern With Us ?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {items.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="relative text-center px-4 lg:border-r lg:last:border-r-0 border-white/20"
              >
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Icon className="w-7 h-7" />
                </div>

                <h3 className="text-white text-sm font-bold mb-2">
                  {item.title}
                </h3>

                <p className="text-gray-300 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
